import React from 'react'
import Head from 'next/head'
import {useRouter} from 'next/router'

import {GetStaticProps} from 'next'
import Header, {IHeader} from '@miro-site/components_header'
import Footer, {IFooter} from '@miro-site/components_footer'
import {PageNotFound} from '@miro-site/components_page-not-found'
import getMenu from '../src/lib/contentful/getMenu'
import {toAbsoluteUrl} from '../src/lib/contentful/helpers'

export const getStaticProps: GetStaticProps = async context => {
  const [header, footer] = await getMenu('en-US')

  return {
    props: {
      header,
      footer,
    },
  }
}

const FourOhFour: React.FC<{header: IHeader; footer: IFooter}> = props => {
  const router = useRouter()

  const {header, footer} = props

  const defaultCanonicalUrl = toAbsoluteUrl(router.pathname)

  return (
    <>
      <Head>
        <title>404 | Miro</title>
        <meta
          name="description"
          content="Miro is an online collaboration software created as a team collaboration and online brainstorming tool. It&#039;s super easy to use &amp; free!"
        />

        <meta name="robots" content="noindex" />
        <link rel="canonical" href={defaultCanonicalUrl} />
      </Head>
      <Header {...header} />
      <main>
        <PageNotFound />
      </main>
      <Footer {...footer} />
    </>
  )
}

export default FourOhFour
